import React from 'react'

import { Router, Switch, Route } from 'react-router-dom'

import history from 'core/history'
import ScrollAfterNav from 'modules/AppFeatures/ScrollAfterNav'

import Embed from '../app/pages/embed' // eslint-disable-line no-restricted-imports

export default class Routes extends React.Component {
  render() {
    return (
      <Router history={history}>
        <React.Fragment>
          <Switch>
            <Route path='/' component={Embed} />
          </Switch>
          <ScrollAfterNav />
        </React.Fragment>
      </Router>
    )
  }
}
